<template>
  <div class="flex-col page2">
    <div class="flex-col">
      <div class="flex-col self-center relative group_5">
        <div class="self-start group_6">
          <span class="font_3">
            帐号信息
            <br />
          </span>
          <span class="font_5 name">公司名称</span>
          <span class="font_5 text_6">{{form.username}}</span>
          <span class="font_6 text_7 btn" @click="handleEdit">
            前往管理
          </span>
          <br />
          <span class="font_5 name">组织机构代码</span>
          <span class="font_5 text_8">{{form.zzjg}}</span>
          <br />
          <span class="font_5 name">法定代表人姓名</span>
          <span class="font_5 text_10">{{form.frdb}}</span>
          <br />
          <span class="font_5 name">公司注册地址</span>
          <span class="font_5 text_11">{{form.gszcd}}</span>
        </div>
        <div class="self-stretch section_5"></div>
        <div class="self-start group_11">
          <span class="font_3">
            申请人信息
            <br />
          </span>
          <span class="font_5 name">申请联系人姓名</span>
          <span class="font_5 text_12">{{form.lxrxm}}</span>
          <br />
          <span class="font_5 name">申请联系人手机号</span>
          <span class="font_5 text_13">{{form.lxrsjh}}</span>
          <span class="font_6"><br /></span>
          <span class="font_5 name">申请联系人邮箱</span>
          <span class="font_5 text_14">{{form.lxrxm}}</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="账号信息修改"
      width="800px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="flex-col section_10 pos">
        <div class="flex-row items-center group_13">
          <p class="row">
            <span class="key">公司名称</span>
            <el-input class="value" placeholder="请输入公司名称" v-model="form.username" :disabled="step != 1"></el-input>
          </p>
          <p class="row">
            <span class="key">组织机构代码</span>
            <el-input class="value" placeholder="请输入机构代码" v-model="form.zzjg" :disabled="step != 1"></el-input>
          </p>
          <p class="row">
            <span class="key">法定代表人姓名</span>
            <el-input class="value" placeholder="请输入代表姓名" v-model="form.frdb" :disabled="step != 1"></el-input>
          </p>
          <p class="row">
            <span class="key">公司注册地</span>
            <el-input class="value" placeholder="请输入公司注册地" v-model="form.gszcd" :disabled="step != 1"></el-input>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      dialogVisible: false,
      step: 1,
      form: {
        username: '', // 公司名称
        zzjg: '', // 组织机构代码
        frdb: '', // 法人代表人姓名
        gszcd: '', // 公司注册地
        lxrxm: '', // 申请联系人姓名
        lxrsjh: '', // 申请联系人手机号
        lxryx: '' // 申请联系人邮箱
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // this.getInfo()
    },
    async getInfo () {
      const res = await this.$https.getUser()
      this.form = res.data
    },
    async submit () {
      const { username, zzjg, frdb, gszcd } = this.form
      const res = await this.$https.updateUser({ username, zzjg, frdb, gszcd })
      console.log('submit==>', res)
      if (res.data.status === 1) {
        this.$message.success('修改成功')
        this.handleClose()
      } else {
        this.$message.error(res.data.msg)
      }
    },
    handleEdit () {
      console.log('handleEdit==>')
      this.dialogVisible = true
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="less">
  .page2 /deep/ .el-dialog__footer{
    display: flex;
    flex-direction: row;
    justify-content: center;

    .el-button{
      background-color: #0071D6;
      border-color: #0071D6;
    }
  }

  .section_10 {
    // padding: 38px 25px 0px 31px;
    .group_13 {
      display: flex;
      flex-direction: column;
      background-color: #fafafa;

      &:nth-child(1) {
        padding-top: 38px;
        padding-right: 25px;
        /*padding-bottom: 142px;*/
        padding-left: 31px;
      }

      &.block2{
        margin-top: 15px;
        padding-top: 38px;
        padding-right: 25px;
        padding-bottom: 45px;
        padding-left: 31px;
      }

      .row{
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top: 0px;

        .key{
          width: 148px;
          text-align: right;
        }

        .value{
          width: 537px;
          height: 35px;
          margin-left: 10px;

          /deep/ input{
            height: 35px;
            line-height: 35px;
            border: 2px solid #CAE3FD;
          }

          /deep/ textarea{
            width: 859px;
            border: 2px solid #CAE3FD;
            resize: none;
          }
        }
      }
    }
    .group_14 {
      margin-top: 19px;
      padding: 0 49px;
    }
    .text-wrapper_2 {
      padding: 10px 0;
      border-radius: 2px;
      background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 538px;
      height: 36px;
      .text_20 {
        margin-left: 19px;
      }
    }
    .group_15 {
      margin-top: 18px;
      padding: 0 33px;
    }
    .group_16 {
      margin-top: 19px;
      padding: 0 64px;
    }
    .group_17 {
      padding: 0 81px;
      .image-wrapper {
        padding: 17px 0 14px;
        border-radius: 2px;
        background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 538px;
        height: 36px;
        .image_5 {
          margin-right: 15px;
          width: 9px;
          height: 5px;
        }
      }
    }
    .view {
      margin-top: 18px;
    }
    .view_2 {
      margin-top: 19px;
    }
    .group_18 {
      margin-top: 25px;
      .text_21 {
        margin-top: 8px;
      }
      .image_6 {
        border-radius: 2px;
        width: 861px;
        height: 114px;
      }
    }
  }
  .flex-col{
    display: flex;
    flex-direction: row;
  }
  .ml-5 {
    margin-left: 5px;
  }
  .mt-108 {
    margin-top: 108px;
  }
  .mt-15 {
    margin-top: 15px;
  }
  .ml-17 {
    margin-left: 17px;
  }
  .mt-27 {
    margin-top: 27px;
  }
  .ml-99 {
    margin-left: 99px;
  }
  .page2 {
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 37px;
      .section {
        padding: 53px 0 49px;
        background-color: #ffffff;
        .text_2 {
          color: #004290;
          font-size: 39px;
          font-family: Swiss721BT;
          font-weight: 900;
          line-height: 29px;
        }
        .text_3 {
          color: #004290;
          font-size: 32px;
          font-family: Alibaba;
          line-height: 31px;
        }
      }
      .section_2 {
        padding: 16px 362px 16px 388px;
        background-color: #006ed1;
        .group_2 {
          margin-left: 85px;
        }
        .group_3 {
          margin-left: 80px;
        }
        .image_2 {
          width: 13px;
          height: 8px;
        }
        .group_4 {
          margin-left: 81px;
        }
        .image {
          width: 28px;
          height: 32px;
        }
        .text_4 {
          color: #ffffff;
        }
      }
    }
    .group_5 {
      display: flex;
      flex-direction: column;
      /*padding: 48px 86px 80px 287px;*/
      /*width: 1439px;*/
      /*border-top: solid 3px #0067d1;*/
      .group_6 {
        /*width: 468px;*/
        .text_6 {
          /*margin-left: 60px;*/
        }
        .text_7 {
          margin-left: 127px;
        }
        .text_8 {
          /*margin-left: 41px;*/
        }
        .text_10 {
          /*margin-left: 32px;*/
        }
        .text_11 {
          /*margin-left: 41px;*/
        }
      }
      .section_5 {
        margin-top: 56px;
        background-color: #e5e5e5;
        height: 2px;
      }
      .group_11 {
        margin-top: 49px;
      }
      .font_3 {
        font-size: 16px;
        font-family: PingFang;
        line-height: 42px;
        color: #333333;
      }
      .font_5 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 42px;
        color: #666666;

        &.name{
          width: 140px;
          display: inline-block;
        }
      }
      .font_6 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 42px;
        color: #0067d1;

        &.btn{
          cursor: pointer;
        }
      }
      .section_3 {
        padding: 57px 24px 313px;
        background-color: #f9f9f9;
        width: 200px;
        .image_3 {
          width: 18px;
          height: 19px;
        }
        .font_4 {
          font-size: 14px;
          font-family: PingFang;
          line-height: 14px;
          color: #666666;
        }
        .text_5 {
          color: #006ed1;
          line-height: 13px;
        }
        .group_7 {
          margin-top: 35px;
          .image_4 {
            width: 18px;
            height: 20px;
          }
        }
        .group_8 {
          margin-top: 36px;
          padding-left: 33px;
          .image_5 {
            width: 20px;
            height: 20px;
          }
          .text_9 {
            line-height: 13px;
          }
        }
        .group_9 {
          margin-top: 34px;
        }
        .group_10 {
          margin-top: 40px;
          .image_6 {
            width: 18px;
            height: 18px;
          }
        }
      }
      .pos {
        position: absolute;
        left: 0;
        top: 0;
      }
      .section_4 {
        background-color: #006ed1;
        width: 5px;
        height: 37px;
      }
      .pos_2 {
        position: absolute;
        left: 0;
        top: 50px;
      }
    }
    .image_7 {
      margin-left: 268px;
      width: 26px;
      height: 26px;
    }
    .section_6 {
      padding: 63px 246px 0;
      background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=5fe9c0f7103aa3f033b6fd2a9cc1a948.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .text-wrapper {
        padding: 14px 0;
        background-color: #006ed1;
        width: 164px;
      }
      .group_12 {
        padding: 26px 6px 49px;
        .text-wrapper_2 {
          flex: 1 1 446px;
          padding: 28px 0;
          background-color: #e0edf9;
          height: 75px;
          border-left: solid 1px #006ed1;
          border-right: solid 1px #006ed1;
          border-top: solid 1px #006ed1;
          border-bottom: solid 1px #006ed1;
        }
      }
    }
    .font {
      font-size: 18px;
      font-family: PingFang;
      line-height: 18px;
      color: #ffffff;
    }
    .font_2 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 16px;
      color: #333333;
    }
    .text {
      text-transform: uppercase;
    }
    .section_7 {
      padding: 8px 234px 36px 360px;
      background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=4d73456eb0616f8bd0f475b81babc110.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .image_8 {
        width: 41px;
        height: 41px;
      }
      .text_15 {
        color: #b2b3b8;
        font-size: 24px;
        font-family: PingFang;
        line-height: 23px;
      }
      .image_9 {
        margin-bottom: 4px;
        width: 40px;
        height: 43px;
      }
      .font_7 {
        font-size: 16px;
        font-family: PingFang;
        line-height: 16px;
        color: #b2b3b8;
      }
      .text_16 {
        line-height: 15px;
      }
      .text_17 {
        color: #006ed1;
        font-size: 24px;
        font-family: PingFang;
        font-weight: 700;
        line-height: 20px;
      }
      .image_10 {
        margin-bottom: 4px;
        width: 31px;
        height: 43px;
      }
      .text_18 {
        color: #006ed1;
        font-size: 20px;
        font-family: PingFang;
        line-height: 19px;
      }
      .section_8 {
        background-color: #2e3142;
        width: 204px;
        height: 188px;
      }
      .font_8 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 11px;
        color: #939598;
      }
      .text_19 {
        margin-left: 3px;
      }
      .text_20 {
        margin-left: 45px;
      }
      .text_21 {
        margin-left: 3px;
      }
    }
  }
</style>
